// extracted by mini-css-extract-plugin
module.exports = {"MainContainer":"News_MainContainer__MO8IZ","News1":"News_News1__3h6Zl","News2":"News_News2__2IUUj","News3":"News_News3__3DH8I"};